
import { Link } from 'react-router-dom';

export default function Features() {
  const features = [
    {
      icon: 'ri-team-line',
      title: 'Partnered Distributors',
      description: 'Access to an extensive network of trusted distributors across Hawaii, ensuring reliable supply chains and quick delivery of quality industrial components.',
      link: '/distributors'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Technical Support',
      description: 'Round-the-clock expert assistance and maintenance services to keep your operations running smoothly without interruption or downtime.',
      link: null
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Custom Solutions',
      description: 'Tailored equipment and technology solutions designed specifically to meet your unique operational requirements and business objectives.',
      link: '/quote'
    }
  ];

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    // Scroll to top after navigation
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
  };

  return (
    <section id="features" className="bg-white py-16 md:py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <span className="text-[#0D1B3E] text-xs md:text-sm font-semibold tracking-[0.15em] uppercase">
            OUR CAPABILITIES
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0D1B3E] mt-4 md:mt-6">
            Comprehensive Solutions
          </h2>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 md:p-10 lg:p-12 border border-gray-200 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
            >
              {/* Icon */}
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-br from-[#0D1B3E] to-[#0066FF] flex items-center justify-center mb-6 md:mb-8">
                <i className={`${feature.icon} text-3xl md:text-4xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl md:text-2xl font-semibold text-[#0D1B3E] mb-3 md:mb-4">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4 md:mb-6">
                {feature.description}
              </p>

              {/* Learn More Link */}
              {feature.link ? (
                <a
                  href={feature.link}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(feature.link);
                  }}
                  className="flex items-center gap-2 text-[#0066FF] font-medium text-sm group-hover:gap-4 transition-all duration-300 cursor-pointer"
                >
                  <span>Learn More</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                </a>
              ) : (
                <div className="flex items-center gap-2 text-[#0066FF] font-medium text-sm group-hover:gap-4 transition-all duration-300 cursor-pointer">
                  <span>Learn More</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-lg"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
